import { render, staticRenderFns } from "./LeadListComponent.vue?vue&type=template&id=be5be31c&scoped=true&"
import script from "./LeadListComponent.vue?vue&type=script&lang=js&"
export * from "./LeadListComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeadListComponent.vue?vue&type=style&index=0&id=be5be31c&scoped=true&lang=scss&"
import style1 from "./LeadListComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5be31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
